var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "docs-area" }, [
    _c("div", { staticClass: "document" }, [
      _c("h1", { staticClass: "page-title" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("terms.h1")) + "\n    "),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "published" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("terms.updated")) + ": 11"),
        _vm._m(0),
        _vm._v(" of April, 2024\n    "),
      ]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          '\n      This Agreement is legally binding between User ("you" or "your") and InFinity Pool Solutions LLC ("Defi Pool", "we", "us" or "our"). By using the Site, you acknowledge that you have read, understood, and agree to be bound by the following terms and conditions (the “Terms”). If you are not eligible, or you do not agree to the Terms, then you do not have our permission to use the Site Eligibility.\n    '
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      You must be at least 18 years of age to use the Site. By agreeing to these Terms, you represent and warrant to us that: (a) you are at least 18 years of age; and (b) your use of the Site is in compliance with any and all applicable laws and regulations. If you are an entity, organization, or company, the individual accepting these Terms on your behalf represents and warrants that they have authority to bind you to these Terms and you agree to be bound by these Terms.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Purchases\n    ")]),
      _vm._v(" "),
      _vm._m(1),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Changes to the Terms\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      We may periodically make changes to these Terms. When we do, we will update the “Last Updated” date above. It is your responsibility to review the most recent version of these Terms and remain informed of any changes. You agree that your continued use of the Site after the effective date of any changes will constitute your acceptance of the changed Terms for your continued use. Disputes arising under these Terms will be resolved in accordance with the version of these Terms that was in effect at the time the dispute arose.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Changes to the Site\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      We reserve the right to modify or discontinue, temporarily or permanently, all or a part of the Site without notice. We will not be liable to you or to any third party for any modification, suspension, or discontinuance of the Site.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Limited License\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Subject to these Terms, Defi Pool grants you a limited, revocable license to access and use the Site solely for non-commercial purposes to learn more about Defi Pool products and services. No other use of the Site is authorized.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Restrictions\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      You must comply with all applicable laws when using the Site. Except as may be expressly permitted by applicable law or expressly permitted by us in writing, you will not, and will not permit anyone else to: (a) store, copy, modify, distribute, or resell any information or material available on the Site (“Site Content”) or compile or collect any Site Content as part of a database or other work; (b) use any automated tool (e.g., robots, spiders) to use the Site or store, copy, modify, distribute, or resell any Site Content; (c) rent, lease, or sublicense your access to the Site; (d) use the Site or Site Content for any purpose except for your own personal use; (e) circumvent or disable any digital rights management, usage rules, or other security features of the Site; (f) reproduce, modify, translate, enhance, decompile, disassemble, reverse engineer, or create derivative works of the Site; (g) use the Site in a manner that threatens the integrity, performance, or availability of the Site; or (h) remove, alter, or obscure any proprietary notices (including copyright notices) on any portion of the Site or Site Content.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Ownership\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      The Site is owned and operated by Defi Pool. We or our licensors retain all right, title, and interest in and to the Site and Site Content and any trademarks, logos, or service marks displayed on the Site or in Site Content (“Marks”). The Site, Site Content, and Marks are protected by applicable intellectual property laws and international treaties. Except as expressly authorized by Defi Pool  you may not make use of the Site, Site Content, and Marks.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Links and Third Party Content\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      The Site may contain links to third party products, services, and websites. We exercise no control over the third party products, services, and websites and we are not responsible for their performance, do not endorse them, and are not responsible or liable for any content, advertising, or other materials available through the third party products, services, and websites. We are not responsible or liable, directly or indirectly, for any damage or loss caused to you by your use of or reliance on any goods or services available through the third party products, services, and websites.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Additionally, if you follow a link or otherwise navigate away from the Site, please be aware that these Terms will no longer govern. You should review the applicable terms and policies, including privacy and data gathering practices, of any third party websites to which you navigate to from the Site.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Disclaimer of Warranties\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      YOUR USE OF THE SITE AND SITE CONTENT IS AT YOUR SOLE RISK. THE SITE AND SITE CONTENT ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. Defi Pool EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. WE DO NOT GUARANTEE THE ACCURACY, COMPLETENESS, OR USEFULNESS OF THE SITE OR SITE CONTENT, AND YOU RELY ON THE SITE AND SITE CONTENT AT YOUR OWN RISK. ANY MATERIAL OBTAINED THROUGH THE SITE IS DONE AT YOUR OWN DISCRETION AND RISK AND YOU WILL BE SOLELY RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER OR LOSS OF DATA THAT RESULTS FROM THE DOWNLOAD OF ANY MATERIAL THROUGH THE SITE. NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY YOU FROM Defi Pool OR THROUGH OR FROM THE SITE WILL CREATE ANY WARRANTY NOT EXPRESSLY STATED IN THIS AGREEMENT. HOWEVER, Defi Pool DOES NOT DISCLAIM ANY WARRANTY OR OTHER RIGHT THAT Defi Pool IS PROHIBITED FROM DISCLAIMING UNDER APPLICABLE LAW.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Limitation of Liability\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      Defi Pool WILL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR EXEMPLARY DAMAGES, INCLUDING BUT NOT LIMITED TO, DAMAGES FOR LOSS OF PROFITS, GOODWILL, USE, DATA OR OTHER INTANGIBLE LOSSES (EVEN IF Defi Pool HAS BEEN ADVISED OF THE POSSIBILITY OF THESE DAMAGES), RESULTING FROM YOUR USE OF THE SITE AND SITE CONTENT. UNDER NO CIRCUMSTANCES WILL Defi Pool S TOTAL LIABILITY OF ALL KINDS ARISING OUT OF OR RELATED TO YOUR USE OF THE SITE OR SITE CONTENT (INCLUDING BUT NOT LIMITED TO WARRANTY CLAIMS), REGARDLESS OF THE FORUM AND REGARDLESS OF WHETHER ANY ACTION OR CLAIM IS BASED ON CONTRACT, TORT, OR OTHERWISE, EXCEED $50. BECAUSE SOME STATES DO NOT ALLOW THE EXCLUSION OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      EACH PROVISION OF THESE TERMS THAT PROVIDES FOR A LIMITATION OF LIABILITY, DISCLAIMER OF WARRANTIES, OR EXCLUSION OF DAMAGES IS INTENDED TO AND DOES ALLOCATE THE RISKS BETWEEN THE PARTIES UNDER THESE TERMS. THIS ALLOCATION IS AN ESSENTIAL ELEMENT OF THE BASIS OF THE BARGAIN BETWEEN THE PARTIES. EACH OF THESE PROVISIONS IS SEVERABLE AND INDEPENDENT OF ALL OTHER PROVISIONS OF THESE TERMS. THE LIMITATIONS IN THIS SECTION WILL APPLY EVEN IF ANY LIMITED REMEDY FAILS OF ITS ESSENTIAL PURPOSE.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Indemnity\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      You will indemnify and hold Defi Pool  and its partners, service providers, affiliates, officers, agents, and employees, harmless from any costs, damages, expenses, and liability caused by your use of the Site or Site Content, your violation of these Terms, or your violation of any rights of a third party through use of the Site or Site Content. We and our licensors reserve the right, at our own expense, to assume the exclusive defense and control of any matter otherwise subject to indemnification by you (without limiting your indemnification obligations with respect to that matter), and in that case, you agree to cooperate with our defense of those claims.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      General Terms\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      These Terms, and any other agreements expressly incorporated by reference into these Terms, are the entire and exclusive understanding and agreement between you and Defi Pool regarding your use of the Site. You may not assign or transfer these Terms or your rights under these Terms, in whole or in part, by operation of law or otherwise, without our prior written consent. We may assign these Terms at any time without notice or consent. The failure to require performance of any provision will not affect our right to require performance at any other time after that, nor will a waiver by us of any breach or default of these Terms, or any provision of these Terms, be a waiver of any subsequent breach or default or a waiver of the provision itself. Use of section headers in these Terms is for convenience only and will not have any impact on the interpretation of any provision. Throughout these Terms the use of the word “including” means “including but not limited to”. If any part of these Terms is held to be invalid or unenforceable, the unenforceable part will be given effect to the greatest extent possible, and the remaining parts will remain in full force and effect.\n    "
        ),
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v("\n      Legal Notices\n    ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      These Terms are governed by the laws of St. Vincent and the Grenadines without regard to conflict of law principles. The exclusive jurisdiction and venue for any claims arising out of or related to these Terms or your use of the Site will be St. Vincent and the Grenadines. In the event that a court of competent jurisdiction finds any provision of these Terms to be illegal, invalid or unenforceable, the remaining provisions will remain in full force and effect.\n    "
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("sup", [_c("small", [_vm._v("th")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", [
      _c("li", [
        _vm._v(
          "\n        Payment: Purchases of any merchandise are facilitated through a third-party service provider. We may provide such service provider with information regarding your credit card or other payment instrument. You represent and warrant that such information is true and that you are authorized to use the payment instrument. You will be responsible for all taxes associated with your purchase of merchandise through the Service.\n      "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n        Loss and Cancellation: Title and risk of loss for all merchandise ordered by you will pass to you on delivery to the shipping carrier. We reserve the right to cancel any order for any merchandise for any reason.\n      "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n        Returns: You acknowledge and agree that goods produced for you are bespoke, custom-made goods. Other than where goods are faulty, you have no right to cancel any order or return any goods and all orders are final.\n      "
        ),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v(
          "\n        Waiver: Your purchase of an item constitutes a waiver of any and all intellectual property, proprietary, personal, and privacy claims relating to that purchase.\n      "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }